import type { CustomDataMap } from "owa-analytics-types";
import type { AddonName } from "./types/AddonName";
import { trace } from "owa-trace";
import type { AnalyticsCoreEventNames, AnalyticsEventNames } from "owa-analytics-events";
import type { MailboxInfo } from "owa-client-types";

let eventQueue: Array<{
    name: AnalyticsEventNames | AnalyticsCoreEventNames;
    mailbox: MailboxInfo | undefined;
    data?: CustomDataMap;
    error?: Error;
    originalData?: CustomDataMap;
}> = [];

/**
 * This package cannot read owa-analytics so we need to add a reference to the
 * logging function we want to use.
 */
export let logGreyError: (name: AnalyticsEventNames | AnalyticsCoreEventNames, mailbox: MailboxInfo | undefined, error?: Error, data?: CustomDataMap) => void;

/**
 * Each thread should indicate when they completed registering the addons.
 */
export function setGreyErrorFunc(logGreyErrorFunction: (name: AnalyticsEventNames | AnalyticsCoreEventNames, mailbox: MailboxInfo | undefined, error?: Error, data?: CustomDataMap) => void): void {
    logGreyError = logGreyErrorFunction;
    
    if (eventQueue.length > 0) {
        processEventQueue();
    }
}

export function logTraceAndEvent(eventName: AnalyticsEventNames | AnalyticsCoreEventNames, mailbox: MailboxInfo | undefined, addon: AddonName, traceMessage: string, customData?: CustomDataMap): void {
    trace.warn(`[Addon] ${traceMessage}`, "analytics");
    
    /* eslint-disable-next-line owa-custom-rules/no-error-dynamic-event-names -- (https://aka.ms/OWALintWiki)
     * Error constructor names can only be a string literals.
     *	> Error constructor names can only be a string literals. Use the diagnosticInfo to add custom data. */
    const error = new Error(eventName);
    
    const data = { addon, ...customData };
    
    if (logGreyError) {
        logGreyError(eventName, mailbox, error, data);
    }
    else {
        eventQueue.push({ name: eventName, mailbox, data, error });
    }
}

function processEventQueue() {
    trace.warn(`[Addon] Processing event queue. ${eventQueue.length} events.`, "analytics");
    
    for (const { name, mailbox, error, data } of eventQueue) {
        logGreyError(name, mailbox, error, data);
    }
    
    eventQueue = [];
}
